var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "videoContent",
      staticClass: "tile__s__video",
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _vm.isHls
        ? _c("Player", { attrs: { content: _vm.content } })
        : _vm.isEmbed
        ? _c("embed-content", {
            attrs: {
              "embed-content": _vm.embedContent,
              "embed-poster": _vm.embedPoster
            }
          })
        : _vm.isYoutube
        ? _c("youtube", { attrs: { "video-id": _vm.videoId } })
        : _vm.isVimeo
        ? _c("vimeo-player", { attrs: { "video-id": _vm.videoId } })
        : _vm.videoUrl
        ? _c(
            "video",
            {
              ref: "video",
              attrs: { controls: "", poster: _vm.posterNoDefault }
            },
            [_c("source", { attrs: { src: _vm.videoUrl } })]
          )
        : _c("img", {
            attrs: {
              src: _vm.imgUrl,
              onerror: "this.src=process.env.DEFAULT_IMAGE",
              alt: ""
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }